module.exports = __webpack_public_path__ + "img/dp11.3e394b6c.jpeg";